/**
 * MetaTags.tsx
 * Version: v01
 * Date: 2025-09-11 (America/Chicago)
 *
 * Reusable SEO meta tag component for DiscountRentersInsurance.com
 * Usage: <MetaTags title="..." description="..." canonicalUrl="..." />
 */

import React from "react";
import { Helmet } from "react-helmet-async";

interface MetaTagsProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  imageUrl?: string;
}

export const MetaTags: React.FC<MetaTagsProps> = ({ title, description, canonicalUrl, imageUrl }) => {
  const defaultImage = ""; // https://www.discountrentersinsurance.com/images/og-image.jpg";

  return (
    <Helmet>
      {/* Standard SEO Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl || defaultImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      {canonicalUrl && <meta name="twitter:url" content={canonicalUrl} />}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl || defaultImage} />
    </Helmet>
  );
};

export default MetaTags;
